export default __webpack_public_path__ + "static/media/O-056.0c6e84bb.png";